import * as RCSlider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { RangeSliderTypes } from './types';

/** @deprecated. Use ui/RangeSlider instead */
export const RangeSliderDeprecated = ({ min, max, setMin, setMax, ...props }: RangeSliderTypes) => {
  // RangeSlider requires values between 0.0-1.0 and it will convert it to 0-100 internally because it doesn't seem to work between 0.0-0.1
  const handleRangeChange = ([currMin, currMax]: number[]) => {
    setMin(currMin / 100);
    setMax(currMax / 100);
  };

  const handleStyle = {
    borderRadius: spacing.half,
    height: spacing.base,
    width: spacing.base,
    backgroundColor: colors.cyan100,
    borderColor: colors.cyan100,
  };

  return (
    <RCSlider.Range
      min={0}
      max={100}
      value={[min * 100, max * 100]}
      onChange={handleRangeChange}
      allowCross={false}
      railStyle={{ backgroundColor: colors.cyan20, height: pxToRem(3) }}
      trackStyle={[{ backgroundColor: colors.cyan100, height: pxToRem(3) }]}
      handleStyle={[handleStyle, handleStyle]}
      {...props}
    />
  );
};
